<template>
  <div class="project-listing" id="project__list">
	<b-modal v-model="showRemoveProjectDeli" type="warn" title="Remove Options">
		<p>Please choose one of the following actions below to remove the deliverable.</p>
		<template #modal-footer>
			<button @click="showRemoveProjectDeli=false" type="button" class="btn btn-secondary">Cancel</button>
			<button @click="deleteDeliverable()" type="button" class="btn btn-danger">Delete Deliverable</button>
			<button @click="onConfirmRemoveProjectDeli" type="button" class="btn btn-primary">Remove just from this Project</button>
		</template>
	</b-modal>
      <div class="project__list">

		<EditProjectModal :projectDeliverables="projectDeliverables" ref="refEditProjectModal"/>

		<b-card no-body class="project--bottom-section" id="projectBottomCard">
			<b-tabs v-model="activeProjectTab" card  content-class="add-project-deliverable-tab">
				<b-tab title="Project deliverables" class="project--deliverable--tab-content">
					<b-card-text>
						<ProjectDeliverableComponent />
					</b-card-text>
				</b-tab>
				<!-- <b-tab title="Notes / Research / CAP Plan">
					<div
					class="field-box field-group"
					v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'notes_research'})"
					:key="index*Math.random()"
					>
						<ProjectCustomFields :deliverable="projectDetail" :customField="field" />
					</div>
					<div
					class="field-box field-group"
					v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'communication_plan'})"
					:key="index*Math.random()"
					>
						<ProjectCustomFields :deliverable="projectDetail" :customField="field" />
					</div>
				</b-tab> -->
				<!-- <b-tab>
					<template v-slot:title>
						<div class="add--project--deliverable--table--img">
							<img src="@/csmworkflow/img/green-plus.svg" alt="plus button"/> Add deliverables
						</div>
					</template>
					<b-card-text>
						<AddProjectDeliverable :removedDeliverableId="removedDeliverableId" />
					</b-card-text>
				</b-tab> -->
				<b-tab title="Project calendar">
					<ProjectCalendar ref="projectCalendarTab" />
				</b-tab>
			</b-tabs>
		</b-card>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProjectCustomFields from "../common/ProjectCustomField";
import EditProjectModal from "./EditProjectModal"
import ProjectDatesRibbon from "./ProjectDatesRibbon";
import vueStarRate from "vue-js-star-rating";
import ProjectDepartments from "./ProjectDepartments";
import EditModal from "./EditModal";
import TaskFields from "./TaskFields";
import CreateContactModal from "./CreateContactModal";
import UpdateContactModal from "./EditContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import UpdateSpokespersonModal from "./EditSpokespersonModal";
import CreateSpokespersonModal from "./CreateSpokespersonModal";
import DeliverableTypeIcon from './DeliverableTypeIcon';
import DuplicateMediaCallFromProjectBtn from "../common/DuplicateMediaCallFromProjectBtn";

import ProjectDeliverableComponent from '@/csmworkflow/js/views/ProjectDeliverableComponent';
import AddProjectDeliverable from '@/csmworkflow/js/views/AddProjectDeliverable';

import UpdateWhoModal from "./EditWhoModal";
import ProjectCalendar from "./ProjectCalendar";
import CreateWhoModal from "./CreateWhoModal";


import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableType from "./DeliverableType";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableListContacts from "./DeliverableListContacts";
import DeliverableListCoordinators from "./DeliverableListCoordinators";
import TaskCompletionGraph from "./TaskCompletionGraph";
import CollapseTaskBtn from "./CollapseTaskBtn";
import DeliverableDatesRibbon from "./DeliverableDatesRibbon";
import toast from '../../toast';

export default {
	data() {
		return {
			removedDeliverableId: false,
			activeProjectTab: 0,
			filterQuery: {
				query: "",
				filterByDate: false,
				filterByDateCreated: false,
				filterByDateCompleted: false,
				dateRange: {
				startDate: new Date(),
				endDate: new Date()
				},
				dateCreatedRange: {
				startDate: new Date(),
				endDate: new Date()
				},
				dateCompletedRange: {
				startDate: new Date(),
				endDate: new Date()
				},
				status: [],
				outlet: [],
				deliverableType: [],
				tag: [],
				department: [],
				coordinator: []
			},
			expandAll: true,
			removingDeliverableId: false,
			showRemoveProjectDeli: false,
			currentProjectTitle: 'Project',
		}
	},
	components: {
		ProjectCustomFields,
		ProjectCalendar,
		AddProjectDeliverable,
		ProjectDeliverableComponent,
		EditProjectModal,
		ProjectDatesRibbon,
		vueStarRate,
		ProjectDepartments,
		EditModal,
		TaskFields,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		DuplicateMediaCallFromProjectBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		ViewTitleModal,
		DeliverableTypeIcon,
		DeliverableProjects,
		DeliverableType
	},
	computed: {
		...mapGetters([
			'projects',
			'projectDeliverables',
			'allProjectDeliverablesPaginationData',
			'projectDetail',
			'deliverableDetail',
			'allContacts',
			"userAbilities",
			'deliverableTypes'
		]),
		_() {
			return _;
		}
	},
	created() {
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchDepartments();
		this.fetchActiveDepartments();
	},
	methods: {
		...mapActions([
			'fetchProjects',
			'fetchDepartments',
			'fetchActiveDepartments',
			'updateFieldValue',
			'fetchUsers',
			'fetchActiveUsers',
		]),
		deleteDeliverable() {
			if (this.removingDeliverableId) {
				let that = this;
				let deliverableId = this.removingDeliverableId;
				this.$store.dispatch("removeDeliverable", { deliverableId:deliverableId }).then(function() {
					toast.hide();
					that.showRemoveProjectDeli=false
					if (that.deliverableDetail.deliverable_template_id == 1) {
						that.$store.dispatch('manageUndoActivation', 'Media call deleted.');
		            } else {
						that.$store.dispatch('manageUndoActivation', 'Deliverable deleted.');
		            }
					that.$store.dispatch('fetchProjectDeliverable');
					that.$store.dispatch("removeProjectDeliverable", { projectId: this.projectDetail.id, deliverableId: this.removingDeliverableId })
				});
				// this.$store
				// 	.dispatch("removeProjectDeliverable", { projectId: this.projectDetail.id, deliverableId: this.removingDeliverableId })
				// 	.then(() => {
				// 		// that.$store.dispatch('manageUndoActivation', 'Deliverable removed from project.');
				// 		that.$store.dispatch("removeDeliverable", { deliverableId:deliverableId }).then(function() {
				// 			that.$store.dispatch('fetchDeliverables').then(function() {
				// 				that.showRemoveProjectDeli=false
				// 				toast.hide();
		        //     if (this.deliverableDetail.deliverable_template_id == 1) {
				// 					that.$store.dispatch('manageUndoActivation', 'Media call deleted.');
		        //     } else {
				// 					that.$store.dispatch('manageUndoActivation', 'Deliverable deleted.');
		        //     }
				// 				that.$store.dispatch('fetchProjectDeliverable');
				// 			});
				// 		});
				// 	});
			}
		},
		deliverableTypeTitle(deliverableTypeId) {
			if(this.deliverableTypes) {
				let typeData = _.filter(this.deliverableTypes, {typeId: deliverableTypeId});
				if(typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},
		onConfirmRemoveProjectDeli() {
			let that = this;
			if(this.removingDeliverableId) {
				this.$store
					.dispatch("removeProjectDeliverable", { projectId: this.projectDetail.id, deliverableId: this.removingDeliverableId })
					.then(() => {
						that.showRemoveProjectDeli=false
						that.removedDeliverableId = that.removingDeliverableId
						that.$store.dispatch('manageUndoActivation', 'Deliverable removed from project.');
						that.$store.dispatch('fetchProjectDeliverable').then(function(response) {
							// that.$store.commit("setProjectDetail", response.data.projectDetail);
						});
					});
			}
		},
		editDeliverableModalHidden() {
			this.$store.commit('setDeliverable', this.deliverableDetail)
		},
		setPriority(deliverable) {
			let priority = $('.listing-priority-del-'+deliverable.id+' .vue-star-rate ul.list li.active').length;
			let priorityData = {
				field_id: 23,
				parentId: null,
				value: priority,
				deliverable_id: deliverable.id,
				id: deliverable.id
			};
			this.updateFieldValue(priorityData);
		},
		editProjectModalHidden() {
			this.$store.commit('setProject', this.projectDetail)
		},
		focusContactModal() {
			this.$refs.refContactModal.focusMyElement();
		},
		focusUpdateContactModal() {
			this.$refs.refUpdateContactModal.focusMyElement();
		},
		focusSpokespersonModal() {
			this.$refs.refSpokespersonModal.focusMyElement();
		},
		focusUpdateSpokespersonModal() {
			this.$refs.refUpdateSpokespersonModal.focusMyElement();
		},
		focusWhoModal() {
			this.$refs.refWhoModal.focusMyElement();
		},
		focusUpdateWhoModal() {
			this.$refs.refUpdateWhoModal.focusMyElement();
		},
		onChangePage(data) {
			this.fetchProjects(data);
		},
		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('project/') == -1) {
				history.pushState(
					{},
					null,
					'project/' + encodeURIComponent(this.projectDetail.id) + '/' + encodeURIComponent(this.projectDetail.slug)
				)
			}
		},
		showModalFn(deliverableId) {
			// shows edit deliverable modal
			this.$store
				.dispatch("getDeliverableDetail", { deliverableId })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show("editDeliverableModal");
				});
		},

		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
				history.pushState(
					{},
					null,
					'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
				this.$router.push({name: 'dashboard'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
			}
		}
	},
	mounted() {
		if(typeof this.$route.query.activeTab != 'undefined') {
			this.activeProjectTab = parseInt(this.$route.query.activeTab)
		}
		let that = this;
		if (!this.projectDetail || !this.projectDetail.id || this.projectDetail.id != this.$router.currentRoute.params.projectId) {
			this.$store.commit("setDataLoading", true);
			this.$store.dispatch('fetchProjectDeliverable').then(() => {
				this.$store.commit("setDataLoading", false);
			});
		}
		if(typeof this.$route.query.activeTab != 'undefined' && this.$route.query.activeTab == '0') {
			this.$nextTick(() => {
				var cardEl = $('#projectBottomCard')[0];
				window.scrollTo(0, cardEl.offsetTop);
			});
		} else {
			this.$nextTick(() => {
				window.scrollTo(0, 0);
			})
		}
		this.$root.$on('showRemoveDeliverableFromProjModal', (deliverableId) => {
			that.removingDeliverableId = deliverableId
			console.log(that.removingDeliverableId)
			that.showRemoveProjectDeli = true
		})
		this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
			if (modalId == "editProjectModal") {
				that.$store.state.deliverables.editProjectModal = false;
				let currentTitle = document.title.match(/\(\d+\)\s/g);
        		if(!currentTitle) {
					document.title = process.env.MIX_APP_NAME;
				} else {
					document.title = currentTitle[0] + process.env.MIX_APP_NAME;
				}
			}
		});
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editProjectModal") {
				this.$store.state.deliverables.editProjectModal = true;
			}
		});
	},
	watch: {
		activeProjectTab: function() {
			if (this.activeProjectTab == 1) {
				this.$nextTick(() => {
					this.$refs['projectCalendarTab'].$refs['csm__project__calendar'].getApi().updateSize();
				})
			}
		}
	}
}
</script>

<style>

</style>
